import { ScoreDisplay } from './ScoreDisplay';
import { StatusContainer } from './StatusContainer';
import { StatusText } from './StatusText';
import { TimeDisplay } from './TimeDisplay';

export interface MatchMetadataProps {
  status: string | null | undefined;
  beginAt: string | undefined;
  team1Score?: number | undefined;
  team2Score?: number | undefined;
}

export const MatchMetadata = ({
  status,
  beginAt,
  team1Score = 0,
  team2Score = 0,
}: MatchMetadataProps) => {
  if (!status) {
    return null;
  }

  if (status === 'finished') {
    return (
      <StatusContainer status={status}>
        <ScoreDisplay score1={team1Score} score2={team2Score} />
      </StatusContainer>
    );
  }

  if (status === 'not_started') {
    return (
      <StatusContainer status={status}>
        <TimeDisplay beginAt={beginAt} />
      </StatusContainer>
    );
  }

  if (status === 'canceled' || status === 'postponed' || status === 'running') {
    return (
      <StatusContainer status={status}>
        <StatusText status={status} />
      </StatusContainer>
    );
  }

  return null;
};
